import { useState } from "react";
import moment from "moment/moment";
import "moment/locale/ar";
import "moment/locale/fr";
import { IoCreateOutline, IoTimeOutline } from "react-icons/io5";
import { BsTrash3 } from 'react-icons/bs';
import IconButton from "../../../../components/Buttons/IconButton";
import DefaultButton from "../../../../components/Buttons/Default";
import '../Forms/NoteTextarea.css';
import { AWS_S3_URL } from "../../../../utils/constants";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function NotePreviewCard({ noteData, onDelete, onEdit }) {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState(noteData?.note_title || '');
  const [body, setBody] = useState(noteData?.note_body || '');

  const handleSave = () => {
    if (!title.trim() || !body.trim()) return;
    onEdit?.(noteData.id, title.trim(), body.trim());
    setEditing(false);
  };

  const handleCancel = () => {
    setTitle(noteData?.note_title || '');
    setBody(noteData?.note_body || '');
    setEditing(false);
  };

  return (
    <div className="d-flex mb-3 position-relative">
      {noteData?.created_by?.profile_picture_path ?
        <img
          src={`${AWS_S3_URL}${noteData.created_by.profile_picture_path}`}
          width={50}
          height={50}
          className="rounded-circle me-2 flex-shrink-0 border"
        />
      :
        <img
          src="https://placehold.co/40"
          width={50}
          height={50}
          className="rounded-circle me-2 flex-shrink-0 border"
        />
      }

      <div className="flex-grow-1">
        {editing ? (
          <div className="note-textarea-container" style={{ marginRight: 0 }}>
            <input
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder={t('crm.notePlaceholderTitle')}
            />
            <textarea
              value={body}
              onChange={e => setBody(e.target.value)}
              placeholder={t('crm.notePlaceholderNote')}
              rows={3}
            />
            <div className="d-flex justify-content-end gap-1 px-2 py-1 border-top">
              <DefaultButton color="secondary" size="sm" onClick={handleCancel}>
                {t('common.cancel')}
              </DefaultButton>
              <DefaultButton
                color="primary"
                size="sm"
                disabled={!title.trim() || !body.trim()}
                onClick={handleSave}
              >
                {t('common.save')}
              </DefaultButton>
            </div>
          </div>
        ) : (
          <>
            <h6 className="fw-bold mb-1">{noteData?.note_title}</h6>
            <p className="mb-2">{noteData?.note_body || t('crm.noDescriptionAvailable')}</p>
            <p className="text-muted small mb-0 d-flex align-items-center">
              <IoTimeOutline className="me-1" />
              {moment(noteData?.created_at).locale(i18next.language).fromNow()} {t('crm.by')} {noteData?.created_by?.firstname || t('common.unknown')}
            </p>
          </>
        )}
      </div>

      {!editing && (
        <div className="position-absolute end-0 top-0 p-2">
          <IconButton color="secondary" outline size="sm" className="me-1" onClick={() => setEditing(true)}>
            <IoCreateOutline />
          </IconButton>
          <IconButton color="danger" outline size="sm" onClick={onDelete}>
            <BsTrash3 />
          </IconButton>
        </div>
      )}
    </div>
  );
}

export default NotePreviewCard;
